import React, { useEffect } from "react";
import { useLang, useT } from "../i18n";
import { WEB3FORMS_KEY, SITE_URL, localizedPath } from "../config/siteConfig";

// Web3Forms-backed contact form (client-side submission + hCaptcha widget).
export default function ContactForm() {
  const lang = useLang();
  const t = useT();
  const c = t.contact;
  const redirectUrl = `${SITE_URL}${localizedPath("success", lang)}`;

  useEffect(() => {
    const scriptId = "jotform-embed-handler";

    function initializeJotform() {
      if (typeof window.jotformEmbedHandler === "function") {
        window.jotformEmbedHandler(
          "iframe[id='JotFormIFrame-262074673669065']",
          "https://form.jotform.com/"
        );
      }
    }

    const existingScript = document.getElementById(scriptId);

    if (existingScript) {
      initializeJotform();
      return;
    }

    const script = document.createElement("script");

    script.id = scriptId;
    script.src =
      "https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js";
    script.async = true;
    script.onload = initializeJotform;

    document.body.appendChild(script);
  }, []);

  return (
    <div className="contact-form">
      <h2>{c.formHeading}</h2>

      <iframe
        id="JotFormIFrame-262074673669065"
        title="Contact Form"
        src="https://form.jotform.com/262074673669065"
        allow="geolocation; microphone; camera; fullscreen; payment"
        frameBorder="0"
        scrolling="no"
        onLoad={() => window.scrollTo(0, 0)}
        style={{
          width: "100%",
          minWidth: "100%",
          maxWidth: "100%",
          height: "539px",
          border: "none",
        }}
      />
      
    </div>
  );
}
